export const homeModule = {
  address: "Address",
  currentAddress: "Current position",
  position: "Relocation",
  positioning: "Positioning",
  positionFail: "Positioning failure",
  addressList: "Address list",
  reposition: "reposition",
  recommendStore: "Recommend store",
  sort1: "Comprehensive ranking",
  sort2: "Favorable comment prioritized",
  sort3: "Consumption per person from low to high",
  sort4: "Consumption per person from high to low",
  sort5: "Lowest delivery fee",
  filterDistance: "Distance",
  filterSales: "Sales volume",
  filter: "Screen",
  filterPrice: "Consumption per person",
  devCondition: "Delivery condition",
  storeType: "Types of dishes",
  manage: "Manage",
  positionError: "If the location time is too long or the location fails, manually select an address",
  changeText: "alter",
  noAddressTitle: "Search the store by address",
  memberPrivilege: "Membership privileges",
  productCoupon: "Value card",
  appointment: "Make an appointment",
  lineUp: "Queue up",
};
export const searchModule = {
  sort: "Ordering",
  addressPlace: "Please input shop name",
  historySearch: "History record",
  noData: "No data"
};
